import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DischargeSummaryComponent} from './discharge-summary.component';
import {routing} from './discharge-summary.routing';
import {SharedTranslationModule} from '../../shared/change-language/shared-translation.module';
import {AutoCompleteModule} from 'primeng/primeng';
import {TrnAdmissionService} from '../../configuration/trn-admission/trn-admission.service';
import {MipdDischargeTemplateService} from '../../configuration/mipd-discharge-template/mipd-discharge-template.service';
import {DischargeSummaryService} from './discharge-summary.service';
import {DpDatePickerModule} from 'ng2-jalali-date-picker';
import {DateConverService} from '../../shared/custom-service/DateConvert.service';

///import {MdsDatetimePickerModule} from "mds.angular.datetimepicker/mds-datetime-picker.module";
@NgModule({
  imports: [
    CommonModule, routing, SharedTranslationModule, AutoCompleteModule, FormsModule, ReactiveFormsModule, DpDatePickerModule
  ],
  declarations: [DischargeSummaryComponent],
  providers: [TrnAdmissionService, MipdDischargeTemplateService, DischargeSummaryService, DateConverService]
})
export class DischargeSummaryModule {
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/ipd/discharge-summary/discharge-summary.module.ts